import SEO from "@/common/components/seo";
import useTermsAndConditions from "../hooks/use-terms-and-conditions";

export default function TermsAndConditionsPage() {
	const { content } = useTermsAndConditions();

	return (
		<div className="flex flex-col gap-8 px-4 py-6 md:gap-16 md:px-105 md:py-25">
			<SEO
				title="Terms & Conditions - Reel Rewards"
				description="Read the Reel Rewards terms and conditions for memberships, entries, giveaways, and use of the platform."
			/>
			<p className="web-heading-h2 text-center">Terms and Conditions</p>
			<p className="web-body-b1 -mt-6 text-center text-gray-700">
				The rules that keep everything fair and clear.
			</p>
			<div dangerouslySetInnerHTML={{ __html: content }} />
		</div>
	);
}
